import { Injectable } from '@angular/core';
import { plainToInstance } from 'class-transformer';
import 'reflect-metadata';
import { CapacityReportingDto } from '../dtos-v2/capacity-reporting.dto';
import { FacilityBedsDto } from '../dtos-v2/facility-beds.dto';
import { CapacityReportingRawType } from '../types-v2/raws/capacity-reporting-raw.type';
import { FacilityBedsRawType } from '../types-v2/raws/facility-beds-raw.type';
@Injectable({ providedIn: 'root' })
export class CapacityTransformerService {
  transformToCapacityReportingDto(
    report: CapacityReportingRawType
  ): CapacityReportingDto {
    return plainToInstance(CapacityReportingDto, report, {
      excludeExtraneousValues: true,
    });
  }

  transformToFacilityBedsDto(report: FacilityBedsRawType): FacilityBedsDto {
    return plainToInstance(FacilityBedsDto, report, {
      excludeExtraneousValues: true,
    });
  }
}
